module.exports = __webpack_public_path__ + "img/swl-banner.2363aec1.png";